import { render, staticRenderFns } from "./columnper.vue?vue&type=template&id=17f17ea2&scoped=true&"
import script from "./columnper.vue?vue&type=script&lang=js&"
export * from "./columnper.vue?vue&type=script&lang=js&"
import style0 from "./columnper.vue?vue&type=style&index=0&id=17f17ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f17ea2",
  null
  
)

export default component.exports